<template>
  <a-form-item v-bind="attrs" :class="bem.b()">
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}" />
    </template>
  </a-form-item>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
// import { FormItem } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'
defineOptions({ name: 'LlFormItem', inheritAttrs: false })
const attrs = useAttrs()

const bem = createNamespace('form-item')
</script>

<style scoped></style>
